import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GetAllDamageTypesService } from './get-all-damage-types.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    GetAllDamageTypesService
  ],
})
export class DamageTypesModule {}
